import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CustomNavbar from './components/Navbar';
import HomePage from './components/HomePage';
import CookieConsent from './components/CookieConsent';
import FooterBottom from './components/footer_bottom';
import ContactPage from './pages/contact';
import JobBoardPage from './jobs/jobs';
import WhatsAppChatInterface from './livechat/chatfeature';
import RequestForm from './services/requestform';
import Servciepage from './services/services';
import AboutPage from './pages/about';
import CaseStudiesPage from './services/casestudy';
import StudioPage from "./business/studio";
import OlewinStudioWelcome from './olewinstudio/studio_welcome';
import TechSolutionsPage from './business/solutionspage';
import BlockchainSolutions from './services/solutions/blockchain';
import EcommerceSolutions from './services/solutions/ecommerce';
import BusinessIntelligence from './services/solutions/businessintelli';
import CloudInfrastructure from './services/solutions/infrapage';
import CustomSoftwareSolutions from './services/solutions/custompage';
import AdvancedCourseNavigation from './components/navigationpage';
import CareerPage from './careers/careers';
import InternshipPage from './internship/internshippage';
import QuantumComputingPage from './futuretech/quantum';
import SpaceTechnologiesPage from './futuretech/spacetech';
import RenewableEnergyPage from './futuretech/renewable';
import BlockchainTechnologies from './futuretech/blockchain';
import AIScientificResearch from './futuretech/science_research';

function App() {

  return (
    <>
    <Router>
      <CustomNavbar/>
      <Routes>
        <Route path='/' element={<HomePage/>}/>
        <Route path='/contact' element={<ContactPage/>}/>
        <Route path='/jobs' element={<JobBoardPage/>}/>
        <Route path='/request_form' element={<RequestForm/>}/>
        <Route path='/services_page' element={<Servciepage/>}/>
        <Route path='/about' element={<AboutPage/>}/>
        <Route path='/case' element={<CaseStudiesPage/>}/>
        <Route path='/studio' element={<StudioPage/>}/>
        <Route path='/studio_page' element={<OlewinStudioWelcome/>}/>
        <Route path='/explore_solutions' element={<TechSolutionsPage/>}/>
        <Route path='/blockchain' element={<BlockchainSolutions/>}/>
        <Route path='/e_commerce' element={<EcommerceSolutions/>}/>
        <Route path='/business_intelligence' element={<BusinessIntelligence/>}/>
        <Route path='/infrastructure' element={<CloudInfrastructure/>}/>
        <Route path='/custom_solutions' element={<CustomSoftwareSolutions/>}/>
        <Route path='/iit-jee' element={<AdvancedCourseNavigation/>}/>
        <Route path='/careers_page' element={<CareerPage/>}/>
        <Route path='/internships' element={<InternshipPage/>}/>
        <Route path='/quantum-computing' element={<QuantumComputingPage/>}/>
        <Route path='/space-technologies' element={<SpaceTechnologiesPage/>}/>
        <Route path='/renewable-energy' element={<RenewableEnergyPage/>}/>
        <Route path='/blockchain-technologies' element={<BlockchainTechnologies/>}/>
        <Route path='/ai-scientific-research' element={<AIScientificResearch/>}/>

       
      </Routes>
 
  <FooterBottom/>
  <CookieConsent/>
 </Router>
 <div>
  <WhatsAppChatInterface/>
 </div>

    </>
      

  );
}

export default App;
